import { Toaster } from "sonner";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Manifesto } from "../components/Manifesto";
import { FoundersSpotlight } from "../components/FoundersSpotlight";
import { Services } from "../components/Services";
import { Materials } from "../components/Materials";
import { Ticker } from "../components/Ticker";
import { MonthlyPricePulse } from "../components/MonthlyPricePulse";
import { OurGroup } from "../components/OurGroup";
import { NetworkTeaser } from "../components/NetworkTeaser";
import { Projects } from "../components/Projects";
import { PropertyDeskTeaser } from "../components/PropertyDeskTeaser";
import { Contact } from "../components/Contact";
import { ExpressInterestForm } from "../components/ExpressInterestForm";
import { Footer } from "../components/Footer";

export default function Home() {
  const location = useLocation();
  // Deep-link support — `/#monthly-price-pulse` or `/#contact` should
  // scroll to the matching section once the page has laid out (the LLM-
  // fetched Monthly Pulse mounts after a network round-trip, so we retry
  // for a few hundred ms).
  useEffect(() => {
    const raw = location.hash?.replace("#", "");
    if (!raw) return;
    let attempts = 0;
    const tick = () => {
      const el = document.getElementById(raw);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (attempts++ < 20) setTimeout(tick, 150);
    };
    tick();
  }, [location.hash, location.pathname]);

  return (
    <main className="bg-[#070707] text-[#F5F5F0]">
      <Toaster position="bottom-right" theme="dark" richColors />
      <Header />
      <Hero />
      <Manifesto />
      <FoundersSpotlight />
      <Services />
      <Materials />
      <Ticker />
      <MonthlyPricePulse />
      <OurGroup />
      <NetworkTeaser />
      <PropertyDeskTeaser />
      <Projects />
      <ExpressInterestForm />
      <Contact />
      <Footer />
    </main>
  );
}
